import { render, staticRenderFns } from "./manageAccess.vue?vue&type=template&id=2721ee5d&scoped=true&"
import script from "./manageAccess.vue?vue&type=script&lang=ts&"
export * from "./manageAccess.vue?vue&type=script&lang=ts&"
import style0 from "./manageAccess.vue?vue&type=style&index=0&id=2721ee5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2721ee5d",
  null
  
)

export default component.exports